import { Typography } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'

import { Tags } from '@/components/tags'
import { useDownloadFileFromReport } from '@/hooks/mutations/use-download-file-from-report'
import { Report } from '@/services/get-economy-reports'

import { useStyles } from './styles'

export interface RowProps {
  row: Report
}

export function Row({ row }: RowProps) {
  const classes = useStyles()

  const { mutate } = useDownloadFileFromReport(row.id)

  return (
    <>
      <TableRow className={classes.row}>
        <TableCell>
          <Typography variant='subtitle1'>{row.created_at}</Typography>
        </TableCell>
        <TableCell>
          <Typography variant='subtitle1'>{row.name}</Typography>
        </TableCell>
        <TableCell>
          <Typography variant='subtitle1'>
            {`${row.start_date} - ${row.end_date}`}
          </Typography>
        </TableCell>
        <TableCell>
          <Tags culture={row.culture} treatment={row.treatment} />
        </TableCell>

        <TableCell>
          <IconButton size='medium' onClick={() => mutate()}>
            <span className='material-symbols-outlined'>download</span>
          </IconButton>
        </TableCell>
      </TableRow>
    </>
  )
}
